class ParallaxBlocks extends HTMLElement {
  constructor() {
    super();
    this.parallaxItems = this.querySelectorAll('.parallax-item');
    if(this.parallaxItems.length === 0) return;
    
    this.observerOptions = {
      rootMargin: '0px',
      threshold: 0.8
    };
  }
  
  connectedCallback() {
    this.handleParallax();
  }

  handleParallax() {
    const observer  = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      })
    }, this.observerOptions)

    this.parallaxItems.forEach(item => {
      observer.observe(item);
    })
  }
}

if(!customElements.get('parallax-blocks')) {
  customElements.define('parallax-blocks', ParallaxBlocks)
}